import "./QualificationApplication.module.css";
import Header from "@/reusable_sections/Header";
import TheQualificationProcess from "./sections/TheQualificationProcess";
import WhatHappensNext from "./sections/WhatHappensNext";
import Footer from "@/reusable_sections/Footer";
export default function QualificationApplicationPage() {
  return <div>
      <Header />
      <TheQualificationProcess />
      <WhatHappensNext />
      <Footer />
    </div>;
}